import React from 'react'
import SharedContextProvider from 'app/shared-components/SharedContext'
import FormWithControls from 'app/shared-components/FormWithControls'
import {
    FeesType,
} from 'app/enums/common.enums'
import useFieldsWithClassName from 'app/hooks/useFieldsWithClassName'
import {
    LongTermLeaseFeeStatus,
} from 'app/enums/label.enums'
import useEnumValues from 'app/hooks/useEnumValues'
import {
    RequestConfig,
} from 'app/types/request.types'

import {
    LongTermLeaseFeeObject,
} from '../LongTermLeaseFees.types'
import useContractBasisContext from '../../hooks/useContractBasisContext'
import useStyles from './LongTermLeaseFeesForm.styles'
import getFields from './LongTermLeaseFeesForm.fields'

const defaultProps = {
    requestParams: undefined,
    customButtons: [],
    disabled: false,
}

export default function LongTermLeaseFeesForm({
    disabled,
    value,
    onSuccess,
    onCancel,
    requestParams,
    customButtons = [],
}: Readonly<{
    disabled?: boolean,
    value: LongTermLeaseFeeObject,
    onSuccess: (el: { id: number }) => void,
    onCancel: () => void,
    requestParams?: RequestConfig,
    customButtons?: JSX.Element[]
}>) {
    const {
        classes,
    } = useStyles()
    const getAllowedValues = useEnumValues()
    const {
        contractId,
    } = useContractBasisContext()

    const exists = Boolean(value?.id)

    const fields = useFieldsWithClassName(
        getFields(
            {
                fees: value?.fees,
                originalStatus: value?.longTermLeaseFeesStatus,
                disabled: value?.longTermLeaseFeesStatus
                    !== LongTermLeaseFeeStatus.IN_PROGRESS || disabled,
                getAllowedValues,
            },
        ),
        classes,
    )

    return (
        <SharedContextProvider
            value={{
                feePricingName: FeesType.LongTermLease,
            }}
        >
            <FormWithControls
                name="LongTermLeaseFees"
                value={{
                    ...value,
                    contractBasis: {
                        id: contractId,
                    },
                }}
                onSuccess={onSuccess}
                fields={fields}
                classNames={{
                    gridWrapper: classes.gridWrapper,
                }}
                disabled={disabled}
                requestParams={requestParams}
                exists={exists}
                onCancel={onCancel}
                customButtons={customButtons}
            />
        </SharedContextProvider>
    )
}

LongTermLeaseFeesForm.defaultProps = defaultProps
